import { LeadsRegistryPage, LeadsRegistryHeader } from './ui';

export const Leads = {
  Page: LeadsRegistryPage,
  Header: LeadsRegistryHeader,
};
